<script setup>
import { computed, inject, reactive, ref, watch } from 'vue';
import { estructura_escolar as apiEstructuraEscolar } from 'cifra-api-js';
import EstructuraEscolar from '../EstructuraEscolar.vue';
import Path, { ordenarPaths } from '../../models/estructura_escolar/Path';

const ESTRUCTURAS_KEY = 'estructuras_escolares';

const I18n = inject('I18n');

const props = defineProps({
  condicion: { type: Object, required: true },
  titulo: { type: String, default: undefined },
  compactar: { type: Boolean, default: false },
});

const condicionInterna = reactive(props.condicion);
const cursos = ref([]);
const cargando = ref(false);
const tituloFinal = computed(() => {
  if (props.titulo !== undefined) {
    return props.titulo;
  }
  return I18n.t('cursos_permitidos');
});
const compactarPaths = computed(() => (
  props.compactar && cursos.value.length > 1
));

// Cargar todos los detalles de las estructuras de una vez
const estructurasIds = props.condicion.config?.[ESTRUCTURAS_KEY] || [];
if (estructurasIds.length > 0) {
  cargando.value = true;

  // Usar la nueva API para obtener múltiples detalles
  apiEstructuraEscolar.getDetalleMultiple(estructurasIds).then((response) => {
    // response.data debería ser un array con los detalles de cada estructura
    response.data.forEach((detalleEstructura) => {
      cursos.value.push(new Path(detalleEstructura));
    });
    cursos.value = ordenarPaths(cursos.value);
  }).catch(() => {
    // Error al cargar estructuras - se maneja silenciosamente
  }).finally(() => {
    cargando.value = false;
  });
}

watch(cursos, () => {
  condicionInterna.config = condicionInterna.config || {
    [ESTRUCTURAS_KEY]: [],
  };

  condicionInterna.config[ESTRUCTURAS_KEY] = cursos.value.map((path) => (
    path.toParamIds()
  ));
}, { deep: true });
</script>

<template>
  <div>
    <div v-if="tituloFinal">
      {{ tituloFinal }}
    </div>
    <div v-if="!cargando" :class="{ 'p-t-sm': !!tituloFinal }">
      <div v-if="!cursos.length">
        Cualquier curso es válido
      </div>
      <template v-if="compactarPaths">
        <span class="label label-default path">
          {{ $t('num_condiciones', { count: cursos.length }) }}
        </span>
      </template>
      <template v-else>
        <div v-for="path in cursos" :key="path" class="m-t-xs">
          <div>
            <EstructuraEscolar :path="path"></EstructuraEscolar>
          </div>
        </div>
      </template>
    </div>
    <div v-else>
      {{ $t('cargando') }}...
    </div>
  </div>
</template>
